<template>
  <el-container v-loading="loading" style="width: 100%">
    <!-- <el-empty v-if="allBooks.length === 0" description="暂无数据" style="margin: 0 auto" /> -->
    <el-row :gutter="0" style="width: 100%">
      <el-col style="height: calc(100vh - 95px);">
        <!-- 页面主体 -->
        <el-row class="main_content_header">
          <el-col :xl="4" :lg="4" :md="5">
            <el-input v-model="searchBook" placeholder="请输入教材名称" @input="handleBookSearch" />
          </el-col>
        </el-row>
        <el-row ref="mainContents">
          <el-scrollbar :height="scrollMaxHeight" style="width: 100%">
            <el-row class="main_content_card">
              <!-- 课程卡片 -->
              <el-empty v-if="allBooks.length === 0" description="暂无数据" style="margin: 0 auto" />
              <el-row v-else :gutter="0" style="width: 100%">
                <el-col :span="24">
                  <el-container class="book_list" :style="styleBookListVar">
                    <div
                      v-for="book in currentBooks"
                      :key="book.isbn"
                      class="book_card"
                    >
                      <el-row :gutter="0" style="cursor: pointer; overflow: hidden;" @click="handleBookJump(book.link)">
                        <el-image v-if="book.pic" :src="book.pic" class="book_image" fit="fill">
                          <template #error>
                            <el-row :gutter="0" class="default_book_img">
                              <span>暂无封面</span>
                            </el-row>
                          </template>
                        </el-image>
                        <el-row v-else :gutter="0" class="default_book_img">
                          <span>暂无封面</span>
                        </el-row>
                      </el-row>
                      <el-row :gutter="0">
                        <el-col :span="24" style="height: 40px">
                          <el-link
                            :href="book.link || ''"
                            target="_blank"
                            :underline="false"
                            class="book_name_link"
                          >
                            <span class="book_name" :title="book.name">
                              {{ book.name }}
                            </span>
                          </el-link>
                        </el-col>
                        <el-col :span="24">
                          <el-tag style="margin-left: 10px; margin-bottom: 5px">
                            {{ book.author }}
                          </el-tag>
                        </el-col>
                        <el-col :span="24">
                          <span style="margin-left: 10px; font-size: 12px" >{{book.publishing_house}} / {{book.publication_date}}</span>
                        </el-col>
                        <el-col :span="24">
                          <span style="margin-left: 10px; font-size: 12px" >{{book.isbn}}</span>
                        </el-col>
                      </el-row>
                    </div>
                  </el-container>
                </el-col>
              </el-row>
            </el-row>
            <div v-loading="loadMore" />
          </el-scrollbar>
        </el-row>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import axios from 'axios'
import Papa from 'papaparse'
import { throttle } from '../utils'

export default {
  name: 'Book',
  data() {
    return {
      allBooks: [],
      loading: false,
      loadMore: false,
      hasMore: false,
      searchBook: '',
      scrollMaxHeight: window.innerHeight - 95 - 72,
      currentBooks: [],
      searchBookList: [],
      fullWidth: document.documentElement.clientWidth, //屏幕宽度
      isMobile: document.documentElement.clientWidth <= 1000, //判断是不是手机端
    }
  },
  mounted() {
    this.fetchCSV()
    this.lazyLoad()
  },
  watch: {
  },
  methods: {
    backToTop() {
      this.$refs.mainContents.$el.querySelector('.el-scrollbar__wrap').scrollTop = 0
    },
    updateBookData(start, end, newBooks) {
      this.currentBooks = []
      if (newBooks) {  // 返回搜索结果
        this.currentBooks.push(...newBooks)
        this.hasMore = false
        return
      }
      this.searchBookList = []
      this.hasMore = true
      this.currentBooks.push(...this.allBooks.slice(start || 0, end || 15))
      this.searchBookList.push(...this.allBooks)
    },
    fetchCSV() {
      let baseURL = this.getBaseUrl()
      axios.get(baseURL + 'book.csv', { responseType: 'blob' })
          .then(res => {
            Papa.parse(res.data, {
              header: true,
              complete: (result) => {
                if (result.errors.length > 0) {
                  let err = result.errors[0].message
                  console.log(err)
                  this.$message.error('获取数据失败。' + err)
                  return
                }
                if (result.data.length > 0) {
                  this.allBooks = result.data
                  this.allBooks.shift()
                  this.updateBookData()
                  // this.lazyLoad()
                }
              },
            });
          })
    },
    getBaseUrl() {
      let url = window.location.href
      url = url.substring(0, url.lastIndexOf('/') + 1)
      // if (process.env.NODE_ENV === "development") {
      //   url = Web_Config.baseURL;
      // }
      return url
    },
    handleBookSearch() {
      this.backToTop()
      if (this.searchBook === '') {
        this.updateBookData()
        return
      }
      const tmpBookList = []
      this.searchBookList.map(b => {
        if (b.name.indexOf(this.searchBook) >= 0) {
          tmpBookList.push(b)
        }
      })
      this.updateBookData(0, 15, tmpBookList)
    },
    handleBookJump(link) {
      window.open(link)
    },
    lazyLoad() {
      const dom = this.$refs.mainContents.$el.querySelector('.el-scrollbar__wrap')
      dom.addEventListener('scroll', throttle((e) => {
        let step = 10
        const isBottom = dom.scrollHeight - dom.scrollTop - dom.clientHeight < 1
        if (this.currentBooks.length >= this.searchBookList.length) {
          this.hasMore = false
          return
        }
        if (isBottom && this.hasMore) {
          this.loadMore = true
          setTimeout(() => {
            this.currentBooks.push(...this.searchBookList.slice(this.currentBooks.length, this.currentBooks.length + step))
            this.loadMore = false
          }, 500)
        }
      }, 200))
    },
  },
  computed: {
    styleBookListVar() {
      return {
        '--book-padding-left': this.isMobile ? (this.fullWidth-260)/2 + 'px' : '0px',
      }
    }
  },
}
</script>

<style>
.main_content_header {
  max-width: 1350px;
  margin: 0 auto;
  padding: 20px;
}
.main_content_card {
  max-width: 1350px;
  margin: 0 auto;
}
.book_list {
  padding-left: var(--book-padding-left);
  overflow: auto;
  flex-wrap: wrap;
  max-width: 1310px;
  margin: 0 auto;
}
.book_card {
  height: 360px;
  width: 240px;
  margin: 10px 10px 30px 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
.book_card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 15px 0 rgba(0, 0, 0, 0.19);
}
.book_image {
  height: 240px;
  width: 100%;
  transition: all 0.5s;
}
.book_image:hover {
  transform: scale(1.1);
}
.default_book_img {
  height: 240px;
  width: 100%;
  font-weight: bold;
  font-size: 30px;
  color: gray;
  padding: 90px;
  background-color: #f4f4f4;
}
.book_name_link {
  margin-left: 10px;
  line-height: 40px;
}
.book_name {
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 230px;
  overflow: hidden;
}
</style>